export default {
  "base": "bg-muted"
}